/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1BossIcon16Solid = forwardRef('People1BossIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" }),
        React.createElement("path", { d: "M2.137 12.607c.41-1.915 1.679-2.819 3.022-3.242l.932 2.135-.78 2.5H3.4c-.773 0-1.425-.637-1.263-1.393Z" }),
        React.createElement("path", { d: "m9.91 11.5.93-2.135c1.344.423 2.613 1.326 3.023 3.242.162.756-.49 1.393-1.263 1.393h-1.912l-.779-2.5Z" }),
        React.createElement("path", { d: "m7.417 11-.98 3.36a.5.5 0 0 0 .48.64h2.166a.5.5 0 0 0 .48-.64L8.583 11c.584-.455.817-.872 1.071-1.681A.246.246 0 0 0 9.417 9H6.592c-.17 0-.29.165-.236.326.253.762.442 1.137 1.06 1.674Z" })));
});
